import { motion } from 'framer-motion'

import { styled } from 'styled-system/jsx'

const PageContainer = styled('div', {
  base: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background:
      'linear-gradient(135deg, {colors.quickpass.surfaceCool} 0%, {colors.quickpass.surface} 60%, #FEF0FF 100%)',
    padding: '24px',
  },
})

const Card = styled(motion.div, {
  base: {
    width: '100%',
    maxWidth: '460px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    boxShadow: '0 24px 60px -20px rgba(128, 84, 255, 0.18)',
    padding: '40px 32px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '14px',
    textAlign: 'center',
  },
})

const Emoji = styled('span', {
  base: {
    fontSize: '64px',
    lineHeight: '1',
  },
})

const Code = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
    color: 'quickpass.primary',
  },
})

const Heading = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '28px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.4px',
  },
})

const Subheading = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    color: 'quickpass.inkSoft',
    margin: '0',
    lineHeight: '1.5',
    maxWidth: '380px',
  },
})

const Actions = styled('div', {
  base: {
    display: 'flex',
    gap: '12px',
    marginTop: '6px',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
})

const PrimaryAction = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '700',
    color: '#FFFFFF',
    backgroundColor: 'quickpass.primary',
    paddingX: '20px',
    paddingY: '10px',
    borderRadius: 'pill',
    border: 'none',
    cursor: 'pointer',
    transition:
      'transform {durations.fast} {easings.appleStandard}, box-shadow {durations.fast} {easings.appleStandard}',
    _hover: {
      transform: 'translateY(-1px)',
      boxShadow: '0 12px 28px -10px rgba(128, 84, 255, 0.5)',
    },
  },
})

const SecondaryAction = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    backgroundColor: 'transparent',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    borderRadius: 'pill',
    paddingX: '16px',
    paddingY: '9px',
    cursor: 'pointer',
    transition:
      'border-color {durations.fast} {easings.appleStandard}, color {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.primary',
      color: 'quickpass.primary',
    },
  },
})

export {
  PageContainer,
  Card,
  Emoji,
  Code,
  Heading,
  Subheading,
  Actions,
  PrimaryAction,
  SecondaryAction,
}
